<script setup lang="ts">
  import pluralize from 'pluralize';

  import { Badge } from '@ui/components/badge';
  import type { BadgeVariants } from '@ui/components/badge';
  import { Tooltip, TooltipContent, TooltipTrigger } from '@ui/components/tooltip';

  interface Props {
    count?: number;
    size?: BadgeVariants['size'];
    variant?: BadgeVariants['variant'];
    withLabel?: boolean;
  }

  withDefaults(defineProps<Props>(), { size: 'md', variant: 'outline' });

  const label = 'Draft';
</script>

<template>
  <Tooltip :disabled="withLabel">
    <TooltipTrigger>
      <Badge
        v-bind="$attrs"
        :variant
        :size
        class="flex flex-row justify-center items-center rounded-full border text-center size-6"
      >
        <i class="fa far fa-pencil text-muted-foreground" />
      </Badge>
    </TooltipTrigger>

    <TooltipContent>
      <span>{{ pluralize(label, count, true) }}</span>
    </TooltipContent>
  </Tooltip>
</template>

<style scoped></style>
